'use client';

import { LoggerInterface } from '@coolblue-development/logging-abstraction';

type Props = {
  logger: LoggerInterface;
  targetBlock: string;
};

const calculateTopPositionOfTargetBlock = (targetBlockElement: Element): number => {
  const headerHeight = 52;
  const padding = 32;
  const headerOffset = headerHeight + padding;
  const targetBlockPosition = targetBlockElement.getBoundingClientRect().top;

  return targetBlockPosition + window.scrollY - headerOffset;
};

export const handleToBlockCallToAction = ({ logger, targetBlock }: Props): void => {
  const targetBlockElement = document.querySelector(`#${targetBlock}`);
  if (!targetBlockElement) {
    logger.error(
      'Could not handle call to action to a block',
      new Error(`Element with id ${targetBlock} was not found`)
    );

    return;
  }

  window.scrollTo({
    top: calculateTopPositionOfTargetBlock(targetBlockElement),
    behavior: 'smooth'
  });
};
